__turbopack_context__.v({
  "image": "YiMx_G_image",
});
